export enum CalendarType {
  Google = 'google',
  Office365 = 'office365'
}